angular.module('common').directive('niceCheckboxInlineError', ['NiceCheckboxInputErrorHandler', 'baseInlineErrorFunctionality', function (NiceCheckboxInputErrorHandler, baseInlineErrorFunctionality) {
  return {
    restrict: 'E',
    scope: true,
    transclude: true,
    template: '<div class="nice-checkbox-inline-error__tooltip-position-wrapper"><span class="inline-error__tooltip skin-tooltip" ng-show="message.content && (hasFocus || hasMouse)">{{message.content}}</span></div>\
      <div class="inline-error__container"><span class="fa-stack nice-checkbox-inline-error__icon">\
      <i class="fa fa-circle fa-stack-2x"></i><i class="fa fa-stack-1x fa-inverse" ng-class="{\'fa-exclamation-triangle\': message.type == \'alert\', \'fa-info\': message.type == \'info\', \'fa-exclamation\': message.type == \'warning\'}"></i>\
      </span>\
      <ng-transclude/></div>',
    link: function ($scope, $element, $attrs) {
      var errorHandler = new NiceCheckboxInputErrorHandler($element);
      errorHandler.onShowMessage(function (message) {
        $scope.message = message;
      });

      $element.on('click', 'nice-checkbox', function() {
        errorHandler.updateMessageVisibility();
        $scope.$digest();
      });

      baseInlineErrorFunctionality('nice-checkbox', $scope, $element, $attrs, errorHandler);
    }
  };
}]);
